import { useModal } from "context/modal-context";

const LetsBuild = () => {
  const { openModal } = useModal();

  return (
    <div className="w-full bg-[#102145] px-6 sm:px-10 xl:px-20 py-16 xl:py-20 flex flex-col items-center gap-8 text-center">
      <h2 data-aos="fade-up" className="text-[28px] sm:text-[36px] xl:text-[44px] font-black text-white leading-tight max-w-[560px]">
        Let's Build Your{" "}
        <span className="text-yellow-100">Technology Capacity</span>
      </h2>

      <p data-aos="fade-up" data-aos-delay="100" className="text-white/75 text-base xl:text-lg max-w-[560px] leading-relaxed">
        Whether you need talent, delivery teams, or workforce development,
        Conclase is ready to support your organization.
      </p>

      <div data-aos="fade-up" data-aos-delay="200" className="flex flex-col items-stretch gap-3 mt-2 sm:flex-row sm:items-center sm:flex-wrap sm:justify-center">
        <button
          onClick={() => openModal("hire-talent")}
          className="w-full sm:w-auto px-7 py-3.5 bg-yellow-100 text-blue-100 font-semibold rounded-full hover:bg-yellow-200 transition-all"
        >
          Hire Tech Talent
        </button>

        <button
          onClick={() => openModal("start-project")}
          className="w-full sm:w-auto px-7 py-3.5 bg-yellow-100 text-blue-100 font-semibold rounded-full hover:bg-yellow-200 transition-all"
        >
          Start a Project
        </button>

        <button
          onClick={() => openModal("become-partner")}
          className="w-full sm:w-auto px-7 py-3.5 bg-transparent text-white font-semibold rounded-full border border-white hover:bg-white hover:text-blue-100 transition-all"
        >
          Partner With Us
        </button>
      </div>
    </div>
  );
};

export default LetsBuild;
